module.exports = __webpack_public_path__ + "media/product/p-5-6159d8a3.png";